<script setup>
import NavBar from './components/NavBar.vue'
import Footer from './components/Footer.vue'
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const showForm = ref(false)

// 控制表单按钮显示
const showFormButton = computed(() => {
  return route.name !== 'contact'
})

// Function to toggle form visibility
const toggleForm = () => {
  showForm.value = !showForm.value
}
</script>

<template>
  <div class="app">
    <NavBar />
    <router-view></router-view>
    <Footer />
    
    <!-- Form toggle button positioned in bottom right -->
    <button v-if="showFormButton" class="form-toggle-btn" @click="toggleForm">
      {{ showForm ? 'Close' : 'Contact' }}
    </button>
    
    <!-- Google Form with conditional display -->
    <div class="google-form-container" :class="{ 'show': showForm }">
      <iframe 
        :src="`https://docs.google.com/forms/d/e/1FAIpQLSejLKZMT18hwPrg5qKiWACdyoPpXvcDbel_7ZLm4tssNjxTOw/viewform?embedded=true`"
        width="340" 
        height="600" 
        frameborder="0" 
        marginheight="0" 
        marginwidth="0">
        Loading…
      </iframe>
    </div>
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

.app {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
}

router-view {
  flex: 1;
}

/* Google Form container styling */
.google-form-container {
  position: fixed;
  bottom: 70px;
  right: 20px;
  z-index: 100;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  background-color: white;
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
  transition: opacity 0.3s, visibility 0.3s, transform 0.3s;
  max-height: 80vh;
  overflow-y: auto;
}

.google-form-container.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* Toggle button styling */
.form-toggle-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 101;
  width: 80px;
  height: 80px;
  background-color: #338a07;
  background: linear-gradient(to bottom, #a10a0a, #700606);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25), 0 4px 6px rgba(0, 0, 0, 0.15);
  transition: background-color 0.2s;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: bold;
  padding: 8px;
}

.form-toggle-btn:hover {
  background-color: #8a0707; /* Darker red on hover */
  color: white;;
}

/* Mobile responsive styles */
@media screen and (max-width: 768px) {
  .form-toggle-btn {
    width: 55px;
    height: 55px;
    font-size: 0.7rem;
    bottom: 15px;
    right: 15px;
  }
  
  .google-form-container {
    bottom: 80px;
    right: 10px;
    width: 300px;
    max-width: 90vw;
  }
  
  .google-form-container iframe {
    width: 100%;
  }
}

/* Small mobile devices */
@media screen and (max-width: 480px) {
  .form-toggle-btn {
    width: 50px;
    height: 50px;
    font-size: 0.65rem;
    bottom: 10px;
    right: 10px;
  }
}
</style>
